import React from "react";
import { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useDispatch } from "react-redux";
import { clearRecurrenceData } from "../../../redux/slices/lomavisCreator/lomavisCreator";
import { useTranslate } from "@tolgee/react";
import { VIEW_STATUS } from "../config/constants";

const ThumbnailEditorConfirmation = ({ handleClose, show, handleClear }) => {
  const dispatch = useDispatch();
  const { t } = useTranslate();
  return (
    <div>
      <Modal centered show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{t("thumbnail_exit.confirmation.header")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{t("thumbnail_exit.confirmation.main")}</Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => {
              handleClose();
              handleClear();
            }}
            variant="secondary"
            size="sm"
          >
            {t("lomavisCreator.modal.discard")}
          </Button>
          <Button size="sm" variant="primary" onClick={handleClose}>
            {t("lomavisCreator.modal.continueEditing")}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ThumbnailEditorConfirmation;
